import { SUBMISSION_STATUS_LABELS } from '@shared/constants/insights-activity';
import { SubmissionStatus } from '@shared/models/submission/status';

export const getStatusLabel = (status: SubmissionStatus) => {
  return SUBMISSION_STATUS_LABELS[status] || status;
};
